export default __webpack_public_path__ + "static/media/NFT_7.ae873896.png";